import { useSelector } from 'react-redux';
import { getWeatherForDate, getWeatherIcon } from '../../../utils/weatherUtils';

/**
 * Hook to handle weather data and related operations
 * @returns {Object} Weather-related utilities and data
 */
export const useWeatherData = () => {
  const weatherData = useSelector((state) => state.weather?.weatherData);

  const getWeatherIconForDate = (date) => {
    if (!weatherData) return null;

    const condition = getWeatherForDate(weatherData, date);
    return condition ? getWeatherIcon(condition) : null;
  };

  return {
    weatherData,
    getWeatherIconForDate,
  };
};
